/**
 * Bridge-layer logger factory.
 *
 * Each driver creates its own Logger via `getBridgeLogger(subkind)` at
 * construction time. Falls back to an off-mode Logger (stdout only) when
 * no LogStore is registered — see @skaile/workspaces/core/logging for details.
 */

import { createLogger } from "@skaile/workspaces/core/logging";
import type { Logger } from "@skaile/workspaces/types";

/**
 * Construct a bridge-scoped Logger for a given driver subkind.
 *
 * Creates a `Logger` with `kind: "bridge"` and the specified `subkind`. Falls back to
 * an off-mode Logger (stdout only) when no `LogStore` is registered — see
 * `@skaile/workspaces/core/logging` for details. Each driver calls this once at construction
 * time; never re-construct per call.
 *
 * @param subkind - Driver id, e.g. `"claude-sdk"`, `"omp"`, `"echo"`, `"codex"`.
 * @returns A `Logger` scoped to `bridge:<subkind>`.
 * @docLink packages/bridge/api-reference#logger
 */
export function getBridgeLogger(subkind: string): Logger {
  return createLogger({ kind: "bridge", subkind });
}
